import PageSeo from '@/components/page-seo';
import { V2Nav } from './landing/components/V2Nav';
import { V2Hero } from './landing/components/V2Hero';
import { V2Canvas } from './landing/components/V2Canvas';
import { V2Features } from './landing/components/V2Features';
import { V2Strip } from './landing/components/V2Strip';
import { V2Pricing, V2FAQ, V2FinalCTA, V2Footer } from './landing/components/V2CTA';
import { T } from './landing/components/V2Tokens';

export default function Welcome() {
    return (
        <>
            <PageSeo
                title="مجرد استديو — Growth Engine للتسويق بالذكاء الاصطناعي"
                description="أول وكالة تسويق بالذكاء الاصطناعي في السعودية. خمسة أقسام متكاملة — تحليل السوق، الاستراتيجية، الإنتاج الإبداعي، إدارة الحملات، وCRM — تعمل كمنظومة واحدة."
                path="/"
                locale="ar_SA"
            />
            <div
                dir="rtl"
                style={{
                    background: T.bg,
                    color: T.ink,
                    fontFamily: '"Alexandria", "Tajawal", "IBM Plex Sans Arabic", system-ui, sans-serif',
                    minHeight: '100vh',
                    // overflow-x must NOT be set here — any non-visible overflow creates a scroll container
                    // that breaks position:sticky for all descendants. Body handles overflow-x via app.css.
                }}
            >
                <V2Nav />
                <main role="main" id="main">
                    <V2Hero />
                    <V2Canvas />
                    {/* 64px gaps let the lavender page background peek through between white sections */}
                    <div style={{ marginTop: 64 }}><V2Features /></div>
                    <div style={{ marginTop: 64 }}><V2Strip /></div>
                    <V2Pricing />
                    <V2FAQ />
                    <div style={{ marginTop: 64 }}><V2FinalCTA /></div>
                </main>
                <V2Footer />
            </div>
        </>
    );
}
